import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./Assets/css/Style.css"
import "./Assets/css/FontAwesome/Css/all.min.css"
import "./Assets/css/FontAwesome/Css/fontawesome.min.css"
import 'cropperjs/dist/cropper.min.css'
import AppRouter from './Router/Route';
import Toast from './Components/Toast';
import Header from './Components/Header';
import Footer from './Components/Footer';
import { useLocation } from 'react-router-dom';
import storage from './Assets/js/Global';
import { useContext } from 'react';
import { GlobalContext } from './Context/GlobalContext';
import SessionLoader from './Components/SessionLoader';

const App = () => {
  const { isSessionRestoring } = useContext(GlobalContext);
  const location = useLocation();
  const authRoutes = [
    '/',
    '/login',
    '/login-v2',
    '/password',
    '/forgot-password',
    '/verify-otp',
    '/create-account-v4',
    '/reset-password',
    '/biometric-required',
    '/delete-account',
    '/create-account-1',
    '/create-account-2',
    '/create-account-3',
    '/create-account-5',
    '/qr-scanner',
    '/update-app'
  ];

  if (
    location.pathname !== "/history" &&
    location.pathname !== "/user-scan-details"
  ) {
    storage.remove("lastSelectedDate");
  }

  const hideHeaderFooter = authRoutes.includes(location.pathname);
  return (
    <>
      <Toast />
      {isSessionRestoring && <SessionLoader />}
      {!hideHeaderFooter && <Header />}
      <div style={{ paddingBottom: hideHeaderFooter ? '0' : '60px' }}>
        <AppRouter />
      </div>
      {!hideHeaderFooter && <Footer />}
    </>
  )
}

export default App;